<template>
  <div>
    <div class="header">
      <div>{{member_name}}</div>
      <el-button
        type="primary"
        @click="onAddClick"
      >新增规格</el-button>
    </div>
    <el-table
      :data="tableData"
      border
      style="width: 100%"
      class="table-wrap"
    >
      <el-table-column
        prop="price"
        label="价格（元）"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="day"
        label="有效期（天）"
        align="center"
      >
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
      >
        <template slot-scope="scope">
          <div class="operation-wrap">
            <span
              class="operation-item"
              @click="handleOperationClick('delete', scope.row)"
            >删除</span>
            <span
              class="operation-item"
              @click="handleOperationClick('edit', scope.row)"
            >编辑</span>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <common-dialog
      :title="dialogTitle"
      :dialogVisible="dialogVisible"
      @cancel="dialogVisible = false"
      @confirm="dialogConfirmClick"
      @dialog-close="dialogClose"
    >
      <div v-if="dialogType === 'add' || dialogType === 'edit'">
        <div class="input-wrap">
          <label>价格:</label>
          <el-input
            v-model="info.price"
            placeholder="请输入价格"
            class="input"
          ></el-input>
        </div>
        <div class="input-wrap">
          <label>有效期（天）:</label>
          <el-input
            v-model="info.day"
            placeholder="请输入有效期"
            class="input"
          ></el-input>
        </div>
      </div>
      <div v-if="dialogType === 'delete'">是否删除此规格？</div>
    </common-dialog>
  </div>
</template>

<script>
import {
  getMemberUnit,
  editMemberUnit,
  addMemberUnit,
  deleteMemberUnit
} from "@/api/member-setting";
import CommonDialog from "@/components/CommonDialog";

export default {
  name: "blank",
  data() {
    return {
      keyword_search: "",
      tableData: [],
      page_index: "1", //第几页
      page_size: "10",
      total: 0, //总条数
      dialogVisible: false,
      info: {},
      dialogType: "",
      member_uuid: "",
      member_name: "",
      dialogTitle: ""
    };
  },
  components: {
    CommonDialog
  },
  mounted() {
    const { uuid, name } = this.$route.query;
    if (uuid) {
      this.member_uuid = uuid;
      this.member_name = name;
      this._getMemberUnit();
    }
  },
  computed: {},
  methods: {
    async _getMemberUnit() {
      const { status, data } = await getMemberUnit({
        member_uuid: this.member_uuid
      });
      if (status === 200) {
        this.tableData = data;
      }
    },
    async dialogConfirmClick() {
      if (this.dialogType === "add" || this.dialogType === "edit") {
        const { price, day } = this.info;
        if (!price) {
          this.$message("请输入价格");
          return;
        }
        if (!day) {
          this.$message("请输入有效期");
          return;
        }
        if (isNaN(day) || day.toString().indexOf(".") !== -1) {
          this.$message("有效期格式错误");
          return;
        }
        this.info.member_uuid = this.member_uuid;
        let resStatus;
        if (this.dialogType === "add") {
          ({ status: resStatus } = await addMemberUnit(this.info));
        } else {
          ({ status: resStatus } = await editMemberUnit(this.info));
        }
        if (resStatus === 200) {
          this.dialogVisible = false;
        }
      }
      if (this.dialogType === "delete") {
        const { status } = await deleteMemberUnit(this.info.uuid);
        if (status === 200) {
          this.dialogVisible = false;
        }
      }
    },
    dialogClose() {
      this.dialogVisible = false;
      this.info = {};
      this._getMemberUnit();
    },
    handleOperationClick(type, row) {
      this.dialogVisible = true;
      this.dialogType = type;
      this.info = JSON.parse(JSON.stringify(row));
      this.dialogTitle = this.dialogType === "edit" ? "编辑规格" : "提示";
    },
    onAddClick() {
      if (this.tableData.length === 3) {
        this.$message("最多可添加3个规格");
        return;
      }
      this.dialogType = "add";
      this.dialogTitle = "添加规格";
      this.dialogVisible = true;
    }
  }
};
</script>

<style lang="less" scoped>
@import "~@/assets/styles/mixins.less";

.header {
  display: flex;
  justify-content: space-between;
}
.input-wrap {
  margin-bottom: 20px;
  label {
    display: block;
    margin-bottom: 10px;
  }
  .input {
    max-width: 300px;
    margin-right: 20px;
  }
}
.table-wrap {
  .table-wrap();
}
</style>
